export const NAMESPACE = 'archives-page';

export const SORT_BY = [{
  label: 'Best Match',
  query: null,
}, {
  label: 'Date Descending',
  query: 'date:desc',
}, {
  label: 'Date Ascending',
  query: 'date:asc',
}];
